import { api } from './configs/axiosConfig';

const endPoint = "/managementops";

export const managementOperationAPI = {
    getpickupPerformance: async function (month, year, pCode) {
        const reponse = await api.request({
            url: endPoint,
            method: 'GET',
            params: { month, year, pCode }
        });

        return reponse.data;
    },

    getCaseReceivedStatus: async function (month, year, pCode) {
        const response = await api.request({
            url: `${endPoint}/case/recevied`,
            method: 'GET',
            params: { month, year, pCode }
        });

        return response.data;
    },

}